import { render, staticRenderFns } from "./PCLayout.vue?vue&type=template&id=66b4a048&scoped=true"
import script from "./PCLayout.vue?vue&type=script&lang=js"
export * from "./PCLayout.vue?vue&type=script&lang=js"
import style0 from "./PCLayout.vue?vue&type=style&index=0&id=66b4a048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4a048",
  null
  
)

export default component.exports